import type { Icon } from '@phosphor-icons/react';
import {
  FileCsvIcon,
  FileDocIcon,
  FileHtmlIcon,
  FileIcon,
  FileImageIcon,
  FileJpgIcon,
  FilePdfIcon,
  FilePngIcon,
  FilePptIcon,
  FileTextIcon,
  FileXlsIcon,
  FileZipIcon,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import {
  attachmentFileType,
  type AttachmentFileType,
} from './attachmentFileType';

const ICONS: Record<AttachmentFileType, { icon: Icon; className: string }> = {
  xls: { icon: FileXlsIcon, className: 'text-green-600 dark:text-green-500' },
  csv: { icon: FileCsvIcon, className: 'text-green-600 dark:text-green-500' },
  pdf: { icon: FilePdfIcon, className: 'text-red-600 dark:text-red-500' },
  png: { icon: FilePngIcon, className: 'text-sky-600 dark:text-sky-500' },
  jpg: { icon: FileJpgIcon, className: 'text-sky-600 dark:text-sky-500' },
  image: { icon: FileImageIcon, className: 'text-sky-600 dark:text-sky-500' },
  doc: { icon: FileDocIcon, className: 'text-blue-600 dark:text-blue-500' },
  ppt: { icon: FilePptIcon, className: 'text-orange-600 dark:text-orange-500' },
  zip: { icon: FileZipIcon, className: 'text-muted-foreground' },
  text: { icon: FileTextIcon, className: 'text-muted-foreground' },
  html: { icon: FileHtmlIcon, className: 'text-muted-foreground' },
  other: { icon: FileIcon, className: 'text-muted-foreground' },
};

/** An attachment's file-type icon — the workbook findable at a glance. */
export function AttachmentFileIcon({
  mimeType,
  fileName,
}: {
  mimeType: string | null | undefined;
  fileName: string;
}) {
  const { icon: TypeIcon, className } =
    ICONS[attachmentFileType(mimeType, fileName)];
  return <TypeIcon className={cn('size-4 shrink-0', className)} />;
}
